import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/koi.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-eef67a4e")

_pushScopeId("data-v-eef67a4e")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "form" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OInputText = _resolveComponent("OInputText")
  const _component_FormField = _resolveComponent("FormField")
  const _component_OPassword = _resolveComponent("OPassword")
  const _component_OButton = _resolveComponent("OButton")
  const _directive_focus = _resolveDirective("focus")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_FormField, {
        label: "Nome",
        invalid: _ctx.v$.form.name.$invalid && _ctx.submitted,
        "invalid-message": "Informe um usuário.",
        "data-test": "fieldName"
      }, {
        default: _withId(() => [
          _withDirectives(_createVNode(_component_OInputText, {
            modelValue: _ctx.form.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
            class: { 'p-invalid': _ctx.v$.form.name.$invalid && _ctx.submitted },
            "data-test": "name",
            onKeyup: _withKeys(_ctx.handleSignin, ["enter"])
          }, null, 8, ["modelValue", "class", "onKeyup"]), [
            [_directive_focus]
          ])
        ]),
        _: 1
      }, 8, ["invalid"]),
      _createVNode(_component_FormField, {
        label: "Senha",
        invalid: _ctx.v$.form.password.$invalid && _ctx.submitted,
        "invalid-message": "Informe uma senha.",
        "data-test": "fieldPassword"
      }, {
        default: _withId(() => [
          _createVNode(_component_OPassword, {
            modelValue: _ctx.form.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.password = $event)),
            "toggle-mask": "",
            feedback: false,
            class: { 'p-invalid': _ctx.v$.form.password.$invalid && _ctx.submitted },
            "data-test": "password",
            onKeyup: _withKeys(_ctx.handleSignin, ["enter"])
          }, null, 8, ["modelValue", "class", "onKeyup"])
        ]),
        _: 1
      }, 8, ["invalid"]),
      _createVNode(_component_OButton, {
        label: "ENTRAR",
        loading: _ctx.loading,
        "data-test": "signin",
        onClick: _ctx.handleSignin
      }, null, 8, ["loading", "onClick"])
    ])
  ]))
})